export default __webpack_public_path__ + "static/media/schulteletters_locked.2afbfb7c.svg";